module.exports = __webpack_public_path__ + "img/GreekTechGreekFire_ua.cb71d027.webp";